import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { DotProps } from './types';

type DotStylesProps = Omit<DotProps, 'innerRef'>;

const DOT_SIZE = 16;

const commonStyles = css`
  border-radius: 50%;
  content: '';
  display: block;
  height: var(--dot-size);
  left: 0px;
  position: absolute;
  top: 0px;
  width: var(--dot-size);
`;

const colorMap = {
  warning: theme.colors.status.warning,
  success: theme.colors.status.success,
  critical: theme.colors.status.critical,
  primary: theme.colors.primary50,
  neutral: theme.colors.neutral20,
};

export type DotThemeValues = typeof colorMap;

export const styles = ({ color, pulsing }: DotStylesProps) => [
  css`
    border-radius: 50%;
    background: ${colorMap[color]};
    position: absolute;
  `,
  !pulsing &&
    css`
      width: ${DOT_SIZE}px;
      height: ${DOT_SIZE}px;
      border: 3px solid ${theme.colors.white};
    `,
  pulsing &&
    css`
      --dot-size: 8px;
      width: var(--dot-size);
      height: var(--dot-size);
      ::after {
        background: ${colorMap[color]};
        ${commonStyles}
        animation: pulse 2s ease 0s infinite;
      }
      @keyframes pulse {
        0% {
          opacity: 0.75;
          transform: scale(1);
        }
        100% {
          opacity: 0;
          transform: scale(2);
        }
      }
    `,
];

export const DotStyles = {
  dot: (props: DotStylesProps) => styles(props),
};
